// extracted by mini-css-extract-plugin
export default {"dropdown_menu":"more_dropdown_menu__dY44B","open":"more_open__A-qi7","platform_item":"more_platform_item__FjMH0"};